import Rellax from 'rellax';

// Mobile detection (borrowed from parallax-container pattern)
window.mobileCheck = function() {
  let check = false;
  (function(a) { 
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; 
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
};

window.isMobile = window.mobileCheck();

// Get current breakpoint based on window width
function getCurrentBreakpoint() {
  const width = window.innerWidth;
  if (width <= 576) return '576';
  if (width <= 1024) return '1024';
  return '1920';
}

// Check if fixed background is enabled for current breakpoint
function isEnabledForBreakpoint(container, breakpoint) {
  const breakpoints = container.dataset.fixedBgBreakpoints;
  if (!breakpoints) return false;
  
  try {
    const breakpointData = JSON.parse(breakpoints);
    return breakpointData[breakpoint] === true;
  } catch (e) {
    return false;
  }
}

// Initialize fixed backgrounds
function initFixedBackgrounds() {
  if (window.isMobile) {
    // Check if any container has mobile enabled
    const containers = document.querySelectorAll('[data-has-fixed-bg="true"]');
    let hasMobileEnabled = false;
    containers.forEach(container => {
      const breakpoints = container.dataset.fixedBgBreakpoints;
      if (breakpoints) {
        try {
          const breakpointData = JSON.parse(breakpoints);
          if (breakpointData['576'] === true) {
            hasMobileEnabled = true;
          }
        } catch (e) {}
      }
    });
    if (!hasMobileEnabled) return;
  }

  const containers = document.querySelectorAll('[data-has-fixed-bg="true"]');
  const currentBreakpoint = getCurrentBreakpoint();

  containers.forEach(container => {
    // Get all background elements (image, video, and gradient)
    const bgElements = [
      container.querySelector('modulr-bg'),
      container.querySelector('video-bg'),
      container.querySelector('.modulr-background-gradient')
    ].filter(el => el !== null);

    if (bgElements.length === 0) {
      console.log('Fixed background: No background elements found in container', container);
      return;
    }

    // Check if enabled for current breakpoint
    if (!isEnabledForBreakpoint(container, currentBreakpoint)) {
      // Destroy existing Rellax instances if any
      bgElements.forEach(bgElement => {
        if (bgElement.rellax) {
          bgElement.rellax.destroy();
          bgElement.rellax = null;
        }
      });
      return;
    }

    // Skip on mobile if not enabled for mobile breakpoint
    if (window.isMobile && currentBreakpoint === '576' && !isEnabledForBreakpoint(container, '576')) {
      bgElements.forEach(bgElement => {
        if (bgElement.rellax) {
          bgElement.rellax.destroy();
          bgElement.rellax = null;
        }
      });
      return;
    }

    const mode = container.dataset.fixedBgMode || 'fixed';
    const speed = parseFloat(container.dataset.fixedBgSpeed || -1);
    
    // For fixed mode, we need the background to counteract scroll exactly
    // Rellax with center:false and a negative speed creates the fixed effect
    const rellaxConfig = {
      center: false,  // Don't use center mode - it dampens the effect
      wrapper: null,
      relativeToWrapper: false,
      round: true,
      vertical: true,
      horizontal: false
    };

    // Initialize Rellax for each background element
    bgElements.forEach(bgElement => {
      // Don't reinitialize if already initialized
      if (bgElement.rellax) return;

      // Add rellax class and speed attribute
      bgElement.classList.add('rellax');
      bgElement.setAttribute('data-rellax-speed', speed);

      // Initialize Rellax
      try {
        bgElement.rellax = new Rellax(bgElement, rellaxConfig);
        console.log('Fixed background: Initialized Rellax for', bgElement.tagName || bgElement.className, 'with speed', speed, 'mode', mode);
      } catch (error) {
        console.error('Fixed background: Error initializing Rellax', error, bgElement);
      }
    });
  });
}

// Destroy all Rellax instances
function destroyFixedBackgrounds() {
  const containers = document.querySelectorAll('[data-has-fixed-bg="true"]');
  containers.forEach(container => {
    const bgElements = [
      container.querySelector('modulr-bg'),
      container.querySelector('video-bg'),
      container.querySelector('.modulr-background-gradient')
    ].filter(el => el !== null);

    bgElements.forEach(bgElement => {
      if (bgElement.rellax) {
        bgElement.rellax.destroy();
        bgElement.rellax = null;
        bgElement.classList.remove('rellax');
        bgElement.removeAttribute('data-rellax-speed');
      }
    });
  });
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
  initFixedBackgrounds();
});

// Reinitialize on resize (with debounce)
let resizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    destroyFixedBackgrounds();
    initFixedBackgrounds();
    initParallaxContainers();
  }, 250);
});

// Initialize parallax containers (scroll-triggered container effect)
function initParallaxContainers() {
  if (window.isMobile) {
    const containers = document.querySelectorAll('[data-container-parallax="true"]');
    let hasMobileEnabled = false;
    containers.forEach(container => {
      const breakpoints = container.dataset.parallaxBreakpoints;
      if (breakpoints) {
        try {
          const breakpointData = JSON.parse(breakpoints);
          if (breakpointData['576'] === true) hasMobileEnabled = true;
        } catch (e) {}
      }
    });
    if (!hasMobileEnabled) return;
  }

  const containers = document.querySelectorAll('[data-container-parallax="true"]');
  const currentBreakpoint = getCurrentBreakpoint();

  containers.forEach(container => {
    const parallaxInner = container.querySelector('.parallax-inner');
    if (!parallaxInner) return;

    const breakpointsData = container.dataset.parallaxBreakpoints;
    const speedData = container.dataset.parallaxSpeed;
    const offsetData = container.dataset.parallaxOffset;
    
    try {
      const breakpoints = JSON.parse(breakpointsData);
      if (breakpoints[currentBreakpoint] !== true) {
        parallaxInner.style.transform = '';
        return;
      }

      const speed = JSON.parse(speedData)?.[currentBreakpoint] || 0.5;
      const baseOffset = JSON.parse(offsetData)?.[currentBreakpoint] || '0px';
      
      // Calculate offset in pixels
      let baseOffsetPx = 0;
      if (baseOffset && baseOffset !== '0px') {
        const match = baseOffset.match(/^([\d.]+)(px|vh|vw)$/);
        if (match) {
          const value = parseFloat(match[1]);
          const unit = match[2];
          if (unit === 'px') baseOffsetPx = value;
          else if (unit === 'vh') baseOffsetPx = (value / 100) * window.innerHeight;
          else if (unit === 'vw') baseOffsetPx = (value / 100) * window.innerWidth;
        }
      }

      // Apply parallax effect with speed and offset
      const windowHeight = window.innerHeight;
      const elementRect = container.getBoundingClientRect();
      const elementBottom = elementRect.bottom;
      const elementTop = elementRect.top;

      let scrollOffset = 0;
      if (elementBottom < windowHeight && elementTop < windowHeight) {
        // Element is entering/within viewport from bottom
        scrollOffset = (windowHeight - elementTop) * speed;
      } else if (elementTop > windowHeight) {
        // Element is below viewport
        scrollOffset = 0;
      } else {
        // Element is above viewport or fully visible
        scrollOffset = (windowHeight - elementTop) * speed;
      }

      const finalOffset = scrollOffset + baseOffsetPx;
      parallaxInner.style.transform = `translateY(${finalOffset}px)`;
    } catch (e) {
      console.error('Parallax container error:', e);
    }
  });
}

// Update parallax containers on scroll
let scrollTimeout;
window.addEventListener('scroll', () => {
  clearTimeout(scrollTimeout);
  scrollTimeout = setTimeout(() => {
    initParallaxContainers();
  }, 10);
});

// Initialize parallax containers on load
document.addEventListener('DOMContentLoaded', () => {
  initParallaxContainers();
});

